module.exports = __webpack_public_path__ + "assets/img/block-870a4319.png";